import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IDeliveryAddress } from '../../../users';

@Component({
  standalone: false,
  templateUrl: './choose-delivery-address-modal.component.html'
})
export class ChooseDeliveryAddressModalComponent {
  @Input() deliveryAddresses: IDeliveryAddress[];
  @Input() deliveryChecker: (deliveryAddress: IDeliveryAddress) => Promise<boolean>;

  busy: Promise<any>;

  public addressAvailabilityMap: { [id: number]: boolean } = {};

  constructor(public modal: NgbActiveModal) {
  }

  async onAddressOpened(panelId: number) {
    const address = this.deliveryAddresses.find((address) => address.id === +panelId);

    if (this.addressAvailabilityMap[address.id]) {
      return this.addressAvailabilityMap[address.id];
    }

    try {
      this.addressAvailabilityMap[address.id] = await this.deliveryChecker(address);
    } catch (e) {
      this.addressAvailabilityMap[address.id] = false;
    }
  }
}
